import { useMutation } from "@tanstack/react-query";
import { useAuthenticatedRequestCreator } from "hooks/useRequests";

const usePotentialSku = () => {
    const fetch = useAuthenticatedRequestCreator<
        { sku: string },
        { packageId: string, isLot: boolean, isGraded: boolean }
    >(
        (data) => ({
            method: "POST",
            url: "/pending-listings/potential-sku",
            data
        })
    );

    return useMutation(fetch);
};

export default usePotentialSku;